import { Clock } from "lucide-react";

export const ComingSoonBadge = ({ label = "Details coming soon" }) => (
  <span
    className="inline-flex items-center gap-1.5 rounded-full border border-gold/50 bg-gold-soft/60 px-3 py-1 text-xs font-semibold tracking-wide text-gold-dark"
    data-testid="coming-soon-badge"
  >
    <Clock className="h-3 w-3" aria-hidden="true" /> {label}
  </span>
);

export const PlaceholderNote = ({ children, testId = "placeholder-note" }) => (
  <div
    className="rounded-xl border border-dashed border-gold/50 bg-gold-soft/40 p-4 text-sm leading-relaxed text-body"
    data-testid={testId}
    role="note"
  >
    {children}
  </div>
);
